import { render, staticRenderFns } from "./UserDetailSummaryTab.vue?vue&type=template&id=42fa263d&scoped=true&lang=pug&"
import script from "./UserDetailSummaryTab.vue?vue&type=script&lang=js&"
export * from "./UserDetailSummaryTab.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailSummaryTab.vue?vue&type=style&index=0&id=42fa263d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fa263d",
  null
  
)

export default component.exports